import Component from './TwitterAnalyticsPublicChart.vue'
export default Component
